import { Parameters } from "../Models/CustomSiteConfigModel";

class ParametersService {
  private parameters: Parameters | null = null;
  private listeners: Array<(parameters: Parameters | null) => void> = [];

  setParameters(newParameters: Parameters) {
    this.parameters = newParameters;
    this.listeners.forEach((callback) => callback(newParameters));
  }

  getParameters(): Parameters | null {
    return this.parameters;
  }

  subscribe(callback: (parameters: Parameters | null) => void): () => void {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter((fn) => fn !== callback);
    };
  }
}

export const parametersService = new ParametersService();
